<template>
    <div class="container-fluid p-0 m-0 pb-5 bg-black" style="min-height: 100%!important;height:auto!important;height: 100%;" v-if="!isMobile()">
        <div class="row g-0 p-0 pb-5 mb-5">
            <div class="col-4">
                <img :src="`${publicPath}img/00homeA.jpg`" class="img-responsive">
            </div>
            <div class="col-4 position-relative">
                <div class="rocaGroup22">
                    <h3>ROCA GROUP</h3>
                    <h4>{{ $t("home.memoriaAnual") }}</h4>
                    <h2>2022</h2>
                </div>
                <div class="homeInfo">
                    <div class="row">
                        <div class="col-4 text-white">
                            <svg viewBox="-5 0 80 75" width="80">
                                <use :href="`${publicPath}icons.svg#personas`"/>
                            </svg>
                            <p class="mt-2">{{ $t("home.personas") }}</p>
                        </div>
                        <div class="col-4 text-white">
                            <svg viewBox="-5 0 80 75" width="80">
                                <use :href="`${publicPath}icons.svg#planeta`"/>
                            </svg>
                            <p class="mt-2">{{ $t("home.planeta") }}</p>
                        </div>
                        <div class="col-4 text-white">
                            <svg viewBox="0 0 80 75" width="80">
                                <use :href="`${publicPath}icons.svg#prosperidad`"/>
                            </svg>
                            <p class="mt-2">{{ $t("home.prosperidad") }}</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-11 m-auto txtGris mt-3">
                            {{ $t("home.elCompromiso") }}
                        </div>
                    </div>
                    <div class="row pb-5">
                        <div class="col-12 py-2">
                            <p>
                              <a href="https://rocagroup.com/memoria_roca_2022/es">
                                CAS
                              </a>|
                              <a href="https://rocagroup.com/memoria_roca_2022/en">
                                ENG
                              </a>
                            </p>

                            <localized-link to="/welcome" class="btn mt-3 text-white px-5">{{ $t("home.entrar") }}</localized-link>
                        </div>
                    </div>
                </div>
                <img :src="`${publicPath}img/00homeB.jpg`" class="img-responsive">
            </div>
            <div class="col-4">
                <img :src="`${publicPath}img/00homeC.jpg`" class="img-responsive">
            </div>
        </div>
    </div>
    <div v-else>
        <div class="container-fluid p-0 m-0 fullHeight" style="background-color: #000000">
            <div class="row">
                <div class="col-12">
                    <localized-link to="/">
                        <img :src="`${publicPath}img/logoRocaGroup_${locale}.png`" width="160" class="img-responsive my-5">
                    </localized-link>
                </div>
            </div>
            <div class="row g-0">
                <div class="col-4 position-relative fullHeight">
                    <div class="col-12 position-absolute bottom-0 mb-4">
                        <svg viewBox="0 0 80 75" width="50">
                            <use :href="`${publicPath}icons.svg#personas`"/>
                        </svg>
                        <p class="text-white">{{ $t("home.personas") }}</p>
                    </div>
                    <img :src="`${publicPath}img/mobile00homeA.jpg`" class="img-responsive">
                </div>
                <div class="col-4 position-relative fullHeight">
                    <div class="col-12 position-absolute bottom-0 mb-4">
                        <svg viewBox="0 0 80 75" width="50">
                            <use :href="`${publicPath}icons.svg#planeta`"/>
                        </svg>
                        <p class="text-white">{{ $t("home.planeta") }}</p>
                    </div>
                    <img :src="`${publicPath}img/mobile00homeB.jpg`" class="img-responsive">
                </div>
                <div class="col-4 position-relative fullHeight">
                    <div class="col-12 position-absolute bottom-0 mb-4">
                        <svg viewBox="0 0 80 75" width="50">
                            <use :href="`${publicPath}icons.svg#prosperidad`"/>
                        </svg>
                        <p class="text-white">{{ $t("home.prosperidad") }}</p>
                    </div>
                    <img :src="`${publicPath}img/mobile00homeC.jpg`" class="img-responsive">
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-10 mt-0 mb-5">
                    <p class="txtGris mt-0">{{ $t("home.elCompromiso") }}</p>
                    <p class="mt-3">
                      <!-- https://rocagroup.com/memoria_roca_2022 -->
                      <a href="https://rocagroup.com/memoria_roca_2022/es">
                        CAS
                      </a>|
                      <a href="https://rocagroup.com/memoria_roca_2022/en">
                        ENG
                      </a>
                    </p>

                    <localized-link to="/menu-mobile" class="btn mt-3 mb-5 text-white px-5">{{ $t("home.entrar") }}</localized-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                publicPath: process.env.BASE_URL,
                locale:this.$i18n.locale,
                isEs:true,
                isEn: false,
            }
        },
        methods: {
            isMobile() {
                if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return true
                } else {
                    return false
                }
            }
        },
        created() {
            // Remove show class from collapsible element to close movile menu
            this.$router.afterEach(() => {
                this.isEs = this.$i18n.locale=="es" ? true : false;
                this.isEn = this.$i18n.locale=="en" ? true : false;
                this.locale = this.$i18n.locale;
            });
        },

    };
</script>
